const promptText = {
    "customerText": {
        "textOne": "Don’t be a solution looking for a problem. Before you decide what you are selling, you have to think about who you are going to sell it to and what problem of theirs are you solving.",
        "textTwo": {
            "one": "Customer Segments are the type of customers you will sell to.",
            "two": "For example, Tesla sells their Model S to a luxury market, while they sell their more affordable Model 3 to the Mass Market.",
            "three": "The more information you have on your target customer, the better you will be able to anticipate your product offerings.",  
        },
        "textThree": {
            "one":"Describe your ideal customer.",
            "two":"You can think of your target customer by either demographics, such as age or gender, or by psychographics, such as interests, motivations, etc.",     
        },
        "textFour": {
            "one": "What are your ideal Customer Segments needs or wants?",
            "two": "Example: You will need to know more about the needs you are fulfilling for your customers. For example, a gluten free bakery understands the dietary restrictions and limited selection people who are gluten free have.",
        },
        "textFive": {
            "one": "Do you have multiple markets you wish to break into, or do you sell to one type of market?",
            "two": "Example: Will you sell directly to customers in your own location, or will you sell to wholesalers and retailers as well?", 
        },  
    },
    "valueText": {
        "textOne": {
            "one": "OK, now we're ready to work on identifying the Value Proposition for your business.",
            "two": "(Your may have more than one, too.)",
        },
        "textTwo": {
            "one": "A value proposition is the promised value you are delivering to your customer.",
            "two": "For example, a Prius provides good gas mileage, safety, and a way to get from point a to point b.",
            "three": "Essentially, a value proposition is a promise that you will deliver some value, rather, the primary reason a prospect should buy from you.",  
        },
        "textThree": {
            "one": "What problem are you solving for your customer or how you're improving their life?",
            "two": "Example - Starbucks gives people access to a desirable environment and their morning cup of coffee.",
            "three": "Write here:",  
    },
        "textFour": {
            "one": "What benefit(s) will your customer get from your product?",
            "two": " For Example - Adidas makes clothes that I can exercise in, feel good in, and appear stylish.",
            "three": "Write here:",  
        },
        "textFive": {
            "one": "Why should your customer buy from you and not your competitors?",
            "two": "For Example - Ben & Jerry’s makes unique ice cream flavors that I can’t get anywhere else.",
            "three": "Write here:",  
        },
    },
    "channelText": {
        "textOne": "Now that we know who you are selling what to, we need to figure out how you will sell it to them., The purpose of understanding our Channels is deciding how your product and brand travels through the customers world. For example, you may have clicked on an ad for Audible, bought a subscription, then downloaded the app on your phone.",
        "textTwo": {
            "one": "Channels are the ways you will communicate to your customers, and how your product can be purchased.",
            "two": "The purpose of understanding our Channels is deciding how your product and brand travels through the customers world.",
            "three": "For example, you may have clicked on an ad for Audible, bought a subscription, then downloaded the app on your phone.",  
        },
        "textThree": {
            "one": "How will you advertise to your customers?",
            "two": "Example: Will you use online ads to reach your customers, or will you schedule meetings with potential customers to pitch your business to them?",
        }, 
        "textFour":{
            "one": "How will your customers purchase your product? ",
            "two": "Example: Will you set up an online store to accept payments, or will your customers go into a physical store to purchase items?",
        },     
        "textFive": {
            "one": "How will you deliver your product to your customers?",
            "two": "Will you ship items to your customers, or will they only be able to purchase in stock items?",
        },     
    },
    "relationshipsText": {
        "textOne": "Now, we are ready to move onto the relationships you will have with your customers.",
        "textTwo": {
            "one": "Customer relationships are the different types of interactions you will have with each customer segment.",
            "two": "It is important to understand what is expected of you, and consider how every type of segment may expect a different type of interaction.",
            "three": "For example, you can give customers the resources to help themselves, or you can offer a 24 hour hotline that they can call.",  
        },
        "textThree": {
            "one": "Will you focus on getting new customers, or keeping old ones?",
            "two": "Example: Will your customers buy your product once, or will you aim to sell to them on a recurring basis? You may sell chains for tires to someone once, but you may cut someone’s hair once every month.",
        }, 
        "textFour":{
            "one": "How will you interact with your customers?",
            "two": "For example, Slack may send out a newsletter or use social media while a business consultant is having in person meetings once a week.",
        },     
        "textFive": {
            "one": "How costly will the level of interaction with your customers cost your business?",
            "two": "For example, phone support will require you hire personnel to be available several hours per day.",
        },     
    },
    "keyActivities": {
        "textOne": "OK, let’s see what key work needs to be done in order to deliver value to your customers.",
        "textTwo": {
            "one": "Key Activities are the items that have to be performed in order to carry out your business.",
            "two": "The purpose of saying our Key Activities is to ensure we make our BMC actionary and we outline what our next steps are.",
            "three": "For example - The Key Activities for a bike shop are to order bikes, market the bikes, and to sell the bikes. Simple enough right?",  
        },
        "textThree": {
            "one": "What Key Activities have to be performed for our value proposition?",
            "two": "For example - If you sell knit sweaters, you have to knit the sweaters!",
        }, 
        "textFour":{
            "one": "What Key Activities have to be performed for our Customer Relationships?",
            "two": "For example - If you are determined to reply to all the emails you get, you have to reply to all the emails you get.",
        },     
        "textFive": {
            "one": "What Key Activities have to be performed for our Channels?",
            "two": "For example - If you have a Canned Pickle business that only ships online, you have to stop by the post office once a week to drop off all of your jars.",
        },     
    },
    "keyPartners": {
        "textOne": "OK, now we must explore what strategic partnerships we can make in order to be even more successful",
        "textTwo": {
            "one": "Key Partners are the relationships you have to make in order to be successful",
            "two": "If you try to do your entire business on your own, you are going to have a very hard time growing and expanding.",
            "three": "For example, Verizon partnered with Apple to give 6 months of free Apple Music.",  
        },
        "textThree": {
            "one": "Who are the most important organizations or groups that you could partner with in order to help your business succeed?",
            "two": "For Example - Amazon partnered with Snapchat by making it possible to purchase items from Amazon by taking a photo of them in Snapchat",
        }, 
        "textFour":{
            "one": "What is a Key Partnership that you could make that would take work that you do not want to focus on and outsource it to a more capable organization?",
            "two": "Example - Many small businesses use Amazon Fulfillment so they do not have to worry about warehousing and shipping",
        },     
        "textFive": {
            "one": "Which key activities do your partners perform?",
            "two": "For example - Apple uses Foxconn for manufacturing instead of doing the labor themselves.",
        },     
    },
    "keyResources": {
        "textOne": "Now, let’s see the resources you have and need.",
        "textTwo": {
            "one": "Key resources are the things that you have that are needed to deliver your value to your customer.",
            "two": "By understanding our Key resources, we can better manage, invest, and distribute the key resources.",
            "three": "For example, a software company needs computer scientists to code, the code they have developed, and the intellectual property on their software.",  
        },
        "textThree": {
            "one": "What are the resources that you have that will be necessary for your Value Proposition?",
            "two": "For example - If you are a table maker, if a tree fell in your backyard, you have your first batch of materials ready.",
        }, 
        "textFour":{
            "one": "What Key Resources will you need to acquire in order to deliver on your business?",
            "two": "For example, if you want to make an app, but have no computer scientists, you need to get some coders.",
        },     
        "textFive": {
            "one": "What resources do you have to reach your Customer Segments right now?",
            "two": "For example - If you have access to the internet, you have access to social media.",
        },     
    },
    "revenueStreams": {
        "textOne": "OK, now we can figure out the fun part, how you will be making money.",
        "textTwo": {
            "one": "Revenue streams are the different ways in which you make money.",
            "two": "The purpose of deciding our streams helps diversify and clarify our business model",
            "three": "For example, Apple makes money through licensing, product sales, patents, and software.",  
        },
        "textThree": {
            "one": "How do your customers currently pay for their desired value?",
            "two": "For example - Uber’s customers paid for Taxis and the bus. ",
        }, 
        "textFour":{
            "one": "What is your business model?",
            "two": "For example…",
            "three": "The types of business models are",
            "four": "Manufacturers make products from raw materials. (FoxCon)",
            "five": "Distributors resell products. (Used Car Lot)",
            "six": "Aggregators connect people and take commissions. (Uber)",
            "seven": "Retailers sell to the public. (Amazon)",
            "eight": "Franchises take a business and license it (McDonalds)",
            "nine": "Bricks and Clicks sell both in a store and online. (Bookstores)",
            "ten": "Freemium is offering a free service than an opportunity to pay for a premium (Us!)",
            "eleven": "Subscription is paying monthly or yearly for a service (Apple Music).",
        },     
        "textFive": {
            "one": "What are all of your revenue streams?",
            "two": "For example - A yoga studio may make money on memberships, drop-ins on classes, the sale of yoga mats, and through hosting events .",
        },     
    },

}

export default promptText;